export default "__VITE_ASSET__BQB5PDVa__"